import { render } from "./HeaderLoggedIn.vue?vue&type=template&id=2fd66871&scoped=true"
import script from "./HeaderLoggedIn.vue?vue&type=script&lang=js"
export * from "./HeaderLoggedIn.vue?vue&type=script&lang=js"

import "./HeaderLoggedIn.vue?vue&type=style&index=0&id=2fd66871&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd66871"]])

export default __exports__